export const heroCarrusel = [
  {
    id: 1,
    poster:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/store/hero/POSTER_DANCE.jpg",
    url: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/store/hero/DANCE_BEYOND_LIMITS.mp4",
    title: "DANCE BEYOND LIMITS",
    houston: true,
    subtitle: "The version of you who shines is already in motion.",
    type: "video",
    label: "Fitting with Nikolay",
    to: "https://calendly.com/nikolayworld/nikolay-orlando-showroom?back=1&month=2025-10",
  },
  {
    id: 2,
    url: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/store/hero/THE_BOYS_&_MEN.jpg",
    title: "THE BOYS & MEN’S",
    houston: false,
    subtitle:
      "Discover the strength, style, and precision of ballet made for him.",
    type: "image",
    label: "Shop",
    to: "/collections/boys-and-mens",
  },

  {
    id: 3,
    url: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/store/hero/TRAINING_TOOLS.jpg",
    title: "TRAINING TOOLS",
    houston: false,
    subtitle:
      "Enhance every practice with the right support for your progress.",
    type: "image",
    label: "Shop",
    to: "/collections/training-tools",
  },
];
